<template>
  <section class="user_login">
    <!-- Page-wrapper-Start -->
    <div class="page_wrapper">
      <!-- Preloader -->
      <!-- <div id="preloader">
        <div id="loader"></div>
      </div> -->

      <div class="full_bg">
        <div class="container">
          <section class="signup_section">
            <div class="top_part">
              <!-- <a href="/" class="back_btn"
                ><i class="icofont-arrow-left"></i> Back</a
              > -->
              <router-link to="/" class="back_btn"><i class="icofont-arrow-left"></i> Back</router-link>
              <!-- <a class="navbar-brand" href="#">
                <img src="images/footer_logo02.png" alt="image" />
              </a> -->

              <router-link to="/" class="navbar-brand"><img src="images/footer_logo02.png" alt="image" /></router-link>
            </div>

            <!-- Comment Form Section -->
            <div class="signup_form">
              <div class="section_title">
                <h2>Welcome to <span>Salt</span></h2>
                <p>
                  Fill all fields so we can get some info about you. <br />
                  We'll never send you spam
                </p>
              </div>
              <form @submit.prevent="submitForm">
                <div class="form-group">
                  <i class="fas fa-envelope"></i>
                  <input
                    type="email"
                    id="form2Example1"
                    class="form-control"
                    placeholder="Email Address"
                    v-model="state.vu_email"
                    v-bind:class="{
                      invaliddata: v$.vu_email.$error == true,
                    }"
                  />
                  <span v-if="v$.vu_email.$error">
                    {{ v$.vu_email.$errors[0].$message }}
                  </span>
                </div>
                <div class="form-group">
                  <i class="fas fa-lock"></i>
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    id="form2Example2"
                    class="form-control"
                    placeholder="Password"
                    v-model="state.vu_password"
                    v-bind:class="{
                      invaliddata: v$.vu_password.$error == true,
                    }"
                  />
                  <i
                :class="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"
                class="password-toggle-icon"
                @click="togglePasswordVisibility"
              ></i>
                  <span v-if="v$.vu_password.$error">
                    {{ v$.vu_password.$errors[0].$message }}
                  </span>
                </div>
                <div class="form-group">
                  <button
                    class="btn puprple_btn"
                    type="button"
                    @click="submitForm"
                  >
                    SIGN IN
                  </button>
                </div>
              </form>
              <p class="or_block">
                <span>OR</span>
              </p>
              <div class="or_option">
                <a href="#">Forgot password?</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- Page-wrapper-End -->
  </section>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.css";
import useVuelidate from "@vuelidate/core";
import { reactive, computed } from "vue";
import { required, minLength, email } from "@vuelidate/validators";
import { mapActions, mapGetters } from "vuex";
import router from "@/router";
import { toast } from "vue3-toastify";

export default {
  name: "User_Login",
  setup() {
    const state = reactive({
      vu_email: "",
      vu_password: "",
    });

    const rules = computed(() => {
      return {
        vu_email: { required, email },
        vu_password: { required, minLength: minLength(3) },
      };
    });

    const v$ = useVuelidate(rules, state);
    return {
      state,
      v$,
    };
  },
  data() {
    return {
      // vu_email: "",
      // vu_password: "",
      // Define a reactive variable to hold the title
      pageTitle: "Salt - User LogIn",
      showPassword : false
    };
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
  },
  methods: {
    ...mapActions(["login"]),
    submitForm() {
      console.log("Hiii");
      try {
        this.v$.$validate();

        if (!this.v$.$error) {
          this.loginForm();
        }
      } catch (error) {
        console.log("Donetttttt");
        console.log(error);
        alert("form failed validation");
      }
    },

    async loginForm() {
      try {
        const userObj = {
          email: this.state.vu_email,
          password: this.state.vu_password,
        };

        let response = await this.login(userObj);
        if (response.user.status === "Active") {
          console.log("Me Again", response);
          setTimeout(() => {
            toast.success(response.message, {
              position: toast.POSITION.TOP_RIGHT,
              timeout: 5000,
              duration: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: true,
              icon: true,
              rtl: false,
            });
          }, 300);
          window.scroll(0, 0);
          router.push({ name: "User_Profile" });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Function to update the title
    updateTitle() {
      document.title = this.pageTitle;
    },

togglePasswordVisibility()  {
  this.showPassword = !this.showPassword;
},


  },
  mounted(){
    this.updateTitle()
  }
};

</script>

<style scoped>
.signup_form form span {
  color: red;
}

.fas.fa-envelope{
    position: absolute;
    z-index: 99;
    /* top: 50%; */
    bottom: 37%;
    left: 3%;
    margin: auto;
}

.fas.fa-lock{
    position: absolute;
    z-index: 99;
    /* top: 50%; */
    bottom: 37%;
    left: 3%;
    margin: auto;
}

.fa.fa-eye-slash, .fa.fa-eye{ position:absolute; right:3%; bottom:37%;}

.signup_form form .form-group {
    position:relative
}
.signup_form form .form-group .form-control {position:relative; padding: 5px 40px;}
</style>
